import graphql from "babel-plugin-relay/macro";

export const createMutation = graphql`
  mutation createMutation(
    $name: String!
    $category: ID
    $difficulty: DifficultyEnum
    $serves: String
    $hotKeep: Boolean
    $description: String
  ) {
    recipeCreate(
      input: {
        name: $name
        category: $category
        difficulty: $difficulty
        serves: $serves
        hotKeep: $hotKeep
        description: $description
      }
    ) {
      recipe {
        id
        name
        picture
      }
    }
  }
`;

export default createMutation;
